<template>
  <main role="main">
    <section class="section section-hero-image">
      <picture>
        <source srcset="@/assets/img/about-s.jpg" media="(max-width: 767px)" />
        <img src="@/assets/img/about.jpg" width="100%" alt="" />
      </picture>
    </section>
    <section class="section section-default section-about">
      <div class="container m-container-only-s">
        <!-- <h1 class="page-header">{{ $t('about.statement') }}</h1> -->
        <div class="hero">
          <h2>{{ $t("about.aboutCompany") }}</h2>
          <p>{{ $t("about.aboutCompanyOne") }}</p>
          <p>{{ $t("about.aboutCompanyTwo") }}</p>
          <p>{{ $t("about.aboutCompanyThree") }}</p>
          <p>{{ $t("about.aboutCompanyFour") }}</p>
        </div>

        <div class="companies">
          <div>
            <img src="@/assets/img/rossiya-logo.svg" alt="" />

            <h3>{{ $t("about.aviaCompanyRossiaTitle") }}</h3>
            <p>{{ $t("about.aviaCompanyRossiaOne") }}</p>
            <p>{{ $t("about.aviaCompanyRossiaTwo") }}</p>
            <p>{{ $t("about.aviaCompanyRossiaThree") }}</p>
          </div>
          <div>
            <img src="@/assets/img/pobeda-logo.png" alt="" />

            <h3>{{ $t("about.aviaCompanyPobeda") }}</h3>
            <p>{{ $t("about.aviaCompanyPobedaOne") }}</p>
            <p>{{ $t("about.aviaCompanyPobedaTwo") }}</p>
          </div>
        </div>

        <div class="full-page">
          <img src="@/assets/img/terminal.jpg" alt="" />
        </div>

        <h2>{{ $t("about.ratingAndAwards") }}</h2>

        <AboutSlider/>

        <div class="full-page">
          <img src="@/assets/img/mountains.jpg" alt="" />
        </div>

        <h2>{{ $t("about.publicRole") }}</h2>
        <div class="columns">
          <div>
            <p>{{ $t("about.publicRoleOne") }}</p>
            <p>{{ $t("about.publicRoleTwo") }}</p>
            <p>{{ $t("about.publicRoleThree") }}</p>
            <p>{{ $t("about.publicRoleFour") }}</p>
          </div>
          <div>
            <p>{{ $t("about.publicRoleFive") }}</p>
            <p>{{ $t("about.publicRoleSix") }}</p>
          </div>
        </div>

        <h2>{{ $t("about.contactInfo") }}</h2>
        <div class="contacts">
          <p>{{ $t("about.countryPostal") }}</p>
          <p>{{ $t("about.street") }}</p>
          <p>
            <a href="">{{ $t("about.link") }}</a>
          </p>
          <p>{{ $t("about.phone") }}</p>
          <p>{{ $t("about.fax") }}</p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import AboutSlider from "@/components/AboutSlider.vue";


export default {
  name: "About",
  components: { AboutSlider }
};
</script>

<style scoped>
main {
  margin-top: -2px;
}
</style>
